export enum BullhornEntityType {
  //region core
  CORPORATE_USER = 'CorporateUser',
  CANDIDATE = 'Candidate',
  JOB_ORDER = 'JobOrder',
  CLIENT_CONTACT = 'ClientContact',
  JOB_SUBMISSION = 'JobSubmission',
  CLIENT_CORPORATION = 'ClientCorporation',
  LEAD = 'Lead',
  OPPORTUNITY = 'Opportunity',
  NOTE = 'Note',
  PLACEMENT = 'Placement',
  APPOINTMENT = 'Appointment',
  TASK = 'Task',
  //endregion
}
